import type { PluralForms } from '@/shared/lib/plural';

export const SUBMISSIONS: PluralForms = ['заявка', 'заявки', 'заявок'];
export const NEW_SUBMISSIONS: PluralForms = ['новая', 'новые', 'новых'];
